import api from '@/helpers/api'

const API_READ = `/api/voucher/`
const API_UPDATE = API_READ
const API_CREATE = API_READ
const API_DELETE = API_READ

export default {
    namespaced: true,
    state: {
        status: '',
        vouchers: [],
        currUser: {},
        errMessage: '',
        meta: {
            page: 1,
            limit: 10,
            total: 1
        },
        filter: {},
        search: {}
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state) {
            state.status = 'error'
        },
        read(state, { vouchers }) {
            state.vouchers = [...vouchers]
        },
        read_single_success(state, { vouchers }) {
            state.vouchers = vouchers
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = { ...filter };
        },
        set_search(state, { search }) {
            state.search = { ...search };
        },
        clear_search(state) {
            state.search = {};
        },
        clear_filter(state) {
            state.filter = {};
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1,
            }
        },
    },
    actions: {
        read({ commit, state }) {
            commit('request');
            const { meta } = state
            const { filter } = state
            const { search } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter, search })
                    .then((result) => {
                        commit('success')
                        commit('read', { vouchers: result.data.data })
                        commit('switch_page', { meta: { ...result.data.meta } })
                        return resolve()
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err);
                    });
            });
        },
        read_single({ commit }, id) {

            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}${id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        delete({ commit, dispatch, state }, id) {

            commit('request');

            // Check if this is the last item on current page (before delete)
            const itemsCount = state.vouchers.length;
            const currentPage = state.meta.page;
            const willBeEmpty = itemsCount === 1 && currentPage > 1;

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_DELETE}${id}`)
                    .then((response) => {
                        // If page will be empty after delete, navigate to previous page first
                        if (willBeEmpty) {
                            const newMeta = { ...state.meta, page: currentPage - 1 };
                            commit('switch_page', { meta: newMeta });
                        }

                        // Reload data
                        dispatch('read');
                        commit('success');
                        return resolve(response.data)
                    }).catch((err) => {
                        commit('err', { message: err });
                        return reject(err.response.data)
                    });
            })
        },
        update({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('put', `${API_UPDATE}${data.id}`, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        create({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_CREATE, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        all({ commit }, id) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}all/${id}`)
                    .then((result) => {
                        commit('read', { vouchers: result.data.data })
                        commit('success')
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        }
    },
    getters: {
        vouchers: () => state => state.vouchers,
    }
}
